import { render, staticRenderFns } from "./ProjectResidential.vue?vue&type=template&id=96bb4618"
import script from "./ProjectResidential.vue?vue&type=script&lang=js"
export * from "./ProjectResidential.vue?vue&type=script&lang=js"
import style0 from "./ProjectResidential.vue?vue&type=style&index=0&id=96bb4618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports